import { CRYSTALLIZE_IDS } from "../crystallize-constants.js";
export const ORDER_STATUS_PIPELINE = {
    NAME: "Florida ordrestatus",
    STAGES: {
        UNKNOWN: "Unknown",
        NEW: "New",
        PARTLY_SHIPPED: "PartlyShipped",
        FINISHED: "Finished",
        CANCELED: "Canceled",
        ERROR: "Error",
    },
};
export const ORDER_META_KEY = {
    ORDER: {
        FIRST_ORDER: "firstOrder",
        SUBSCRIPTION_CONTRACT_ID: "subscriptionContractId",
        ORDER_TYPE: "orderType",
        ORIGINAL_ORDER_ID: "originalOrderId",
        CREDIT_ORDER_IDS: "creditOrderIds",
        RETURN_ORDER_IDS: "returnOrderIds",
        ORDER_SOURCE: "orderSource",
        SKU: "sku",
        BATCH_CODE: "dispatchBatchCode",
    },
    ORDER_ITEM: {
        GIFT: "gift",
        REGULATED_PRICE: "regulatedPrice",
        TRACK_PROGRESSION_INDEX: "trackProgressionIndex",
        BINDING: "Innbinding",
        AUTHOR: "Forfattervisning",
        UNIVERSE: "universe",
    },
    UNIVERSE: "universe",
    BUYER_REFERENCE: "buyerReference",
    EXTERNAL_REFERENCE: "externalReference",
    CART_ID: "cartId",
    CLERK_USER_ID: "clerkUserId",
    SHIPMENT_TYPE: "shipmentType",
};
export var OrderType;
(function (OrderType) {
    OrderType["BOOK_SUBSCRIPTION"] = "bookSubscription";
    OrderType["SERIES_SUBSCRIPTION"] = "seriesSubscription";
    OrderType["BOOK_CLUB"] = "bookClub";
    OrderType["CREDIT"] = "credit";
    OrderType["RETURN"] = "return";
    OrderType["SALES"] = "sales";
    OrderType["REPLACEMENT"] = "replacement";
    OrderType["PARTIAL_DELIVERY"] = "partialDelivery";
    OrderType["EVALUATION_COPY"] = "evaluationCopy";
})(OrderType || (OrderType = {}));
export const SHAPE_IDENTIFIERS = {
    BOOK: CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK.ID,
    FREIGHT: "frakt",
    PRODUCT: "produkt",
    SERIES_SUBSCRIPTION: "seriekampanje",
    SUBSCRIPTION: "abonnement",
    BOOK_CLUB: "bokklubb",
};
